import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
//HttpClient
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import { of } from 'rxjs/observable/of';
import {map} from 'rxjs/operators';

const PARAMS = new HttpParams({
  fromObject: {
    action: 'opensearch',
    format: 'json',
    origin: '*'
  }
});

@Injectable()
export class ClientesService {

  private service_url;
  constructor(
    private constantsService: ConstantsService, 
    private http: Http, 
    private authService: AutenticacionService, 
    private validatorService: ValidatorService, 
    private errorService: ErrorsService,
    private httpClient : HttpClient) {
    this.service_url = this.constantsService.apiURL + '/clientes';
  }

  public get(id:number) {
    return this.http.get(this.service_url + "/" + id, this.authService.getAuthHeaders());
  }

  public update(client : object) {
    return this.http.put(this.service_url , client, this.authService.getAuthHeaders());
  }

  public search( filters: any) {
    const headers = this.authService.getHttpClientHeaders();
    let requestdata = {
      params: null,
      headers: headers
    }
    
    if(filters.nombre){
      //Se consultara el servicio cuando el termino ingresado tenga una longitud superior a 2 chars
      if (filters.nombre.length <= 2) {
        return of([]);
      }

      requestdata.params  = PARAMS.set('nombre', filters.nombre);
    }
    
    if(filters.email){
      //Se consultara el servicio cuando el termino ingresado tenga una longitud superior a 2 chars
      if (filters.email.length <= 2) {
        return of([]);
      }

      requestdata.params  = PARAMS.set('email', filters.email);

    }

    if(!requestdata.params){
      return of([]);
    }

    return this.httpClient
      .get(this.service_url, requestdata).pipe(
        map( function(response : any){
          //Return the clientes array
          return response.content;
        })
      );
  }

  public validate(data: any){
    let error = [];

    if(!this.validatorService.required(data.tipo_persona)){
      error["tipo_persona"] = this.errorService.required;
    } 
    
    if(data.tipo_persona === 'FISICA'){
      //Persona física
  
      if(!this.validatorService.required(data.email)){
        error["email"] = this.errorService.required;
      }
      else if (!this.validatorService.email(data.email)) {
        error['email'] = this.errorService.email;
      }
  
      if(!this.validatorService.required(data.clave_elector)){
        error['clave_elector'] = this.errorService.required;
      }
  
    }else{
      //Persona modal
      if(!this.validatorService.required(data.representante_nombre)){
        error["representante_nombre"] = this.errorService.required;
      }    
  
      if(!this.validatorService.required(data.representante_clave_elector)){
        error["representante_clave_elector"] = this.errorService.required;
      }
  
      if(!this.validatorService.required(data.representante_rfc)){
        error["representante_rfc"] = this.errorService.required;
      }
  
      if(!this.validatorService.required(data.representante_curp)){
        error["representante_curp"] = this.errorService.required;
      }
  
      if(!this.validatorService.required(data.representante_telefono)){
        error["representante_telefono"] = this.errorService.required;
      }
    }

    //Validaciones comunes para persona moral y persona física
    if(!this.validatorService.required(data.nombre)){
      error["nombre"] = this.errorService.required;
    }    

    if(!this.validatorService.required(data.rfc)){
      error["rfc"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.direccion)){
      error["direccion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.poblacion)){
      error["poblacion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.telefono)){
      error["telefono"] = this.errorService.required;
    }
    
    return error;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/clientes.service.ts